import React, { forwardRef } from 'react'

import Box, { type BoxProps } from '../box'

export type RowProps = BoxProps

const Row = forwardRef<HTMLElement, RowProps>((props, ref) => (
  <Box ref={ref} flexDirection='row' flex='1 0 auto' {...props} />
))
Row.displayName = 'Row'

export default Row
